export default "__VITE_ASSET__93d84a5d__"